export const ChainIdMap = {
    AELF: '9992731',
    tDVV: '1866392',
    tDVW: '1931928',
};
